// 游戏模块上下文

import { createContext, useContext, ReactNode, useState, useMemo } from "react";
import { useBaseCache } from "../../base/contexts";

// Context类型定义
interface GameContextType {
  // 基础缓存
  cache: ReturnType<typeof useBaseCache>;
  // 嵌入页面URL
  embedPage: string;
  setEmbedPage: (url: string) => void;
}

// 创建Context
const GameContext = createContext<GameContextType | null>(null);

// Provider Props
interface GameContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function GameContextProvider({ children }: GameContextProviderProps) {
  const cache = useBaseCache();
  const [embedPage, setEmbedPage] = useState<string>("");

  const value: GameContextType = useMemo(
    () => ({
      cache,
      embedPage,
      setEmbedPage,
    }),
    [cache, embedPage]
  );

  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
}

// Hook
export function useGameContext(): GameContextType {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGameContext must be used within GameContextProvider");
  }
  return context;
}

// 便捷hooks
export function useGameCache() {
  const { cache } = useGameContext();
  return cache;
}
